import { render, staticRenderFns } from "./studioDashboardDaycare.vue?vue&type=template&id=61e0ba2e&scoped=true"
import script from "./studioDashboardDaycare.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0ba2e",
  null
  
)

export default component.exports